module.exports = __webpack_public_path__ + "static/media/login.559259dc.svg";